<template>
  <v-dialog
    content-class="edit-credentials-popup"
    :value="visiblePopup"
    :max-width="532"
    @click:outside="onCloseClick"
    @keydown.esc="onCloseClick"
  >
    <v-card class="popup-wrapper">
      <div class="content">
        <div class="edit-title">
          {{ $t('project.edit.credentials') }}
        </div>
        <resource-credentials-form :resource="resourceForEdit" :resourceNumber="resourceNumber" />
      </div>
      <div class="buttons">
        <v-btn small depressed class="cancel-button" @click="onCloseClick"> {{ $t('confirm.cancel') }} </v-btn>
        <v-btn small depressed class="save-button" @click="onSaveClick" :disabled="saveDisabled">
          {{ $t('project.save.changes') }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { cloneDeep } from 'lodash';
import ResourceCredentialsForm from '@/components/ProjectDetails/credentials/ResourceCredentialsForm.vue';
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

export default {
  name: 'EditCredentialsPopup',
  mixins: [disableOuterScrollOnPopupVisible],
  components: {
    ResourceCredentialsForm,
  },
  props: {
    visiblePopup: {
      type: Boolean,
      default: false,
    },
    resource: {
      type: Object,
      required: true,
    },
    resourceNumber: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      resourceForEdit: cloneDeep(this.resource),
    };
  },
  computed: {
    saveDisabled() {
      return (
        this.resourceForEdit.credentials.length < 1 ||
        this.resourceForEdit.credentials.some(cred => !(cred.username && cred.password))
      );
    },
  },
  watch: {
    visiblePopup(newValue, oldValue) {
      if (!oldValue && newValue) {
        this.resourceForEdit = cloneDeep(this.resource);
      }
    },
  },
  methods: {
    onCloseClick() {
      this.$emit('close');
    },
    onSaveClick() {
      this.$emit('save', this.resourceForEdit);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.edit-credentials-popup {
  .popup-wrapper {
    max-width: rem(532);
    padding: $space-8 $space-10;

    .content {
      .edit-title {
        text-transform: uppercase;
        color: var(--text-primary);
        font-size: $font-size-base;
        font-weight: 600;
        letter-spacing: 1.12px;
        line-height: $space-4;
      }
    }

    .buttons {
      text-align: right;
      padding-top: rem(30);

      .cancel-button {
        box-sizing: border-box;
        height: $space-8;
        width: rem(86);
        border: $border-width-thin solid var(--brand-primary);
        color: var(--brand-primary);
        border-radius: $radius-sm;
        background-color: var(--bg-primary);
        box-shadow: $shadow-sm;
      }

      .save-button {
        height: $space-8;
        width: rem(51);
        border-radius: $radius-sm;
        background-color: var(--brand-primary);
        box-shadow: $shadow-sm;
        color: var(--text-inverse);
        font-size: $font-size-sm;
        font-weight: 500;
        letter-spacing: 1.07px;
        line-height: $space-4;
        text-align: center;
        margin-left: $space-2;
      }
    }
  }
}
</style>
